<template>
  <div>
    <v-text-field
      :value="value.title"
      label="Main Title"
      outlined
      dense
      @input="update('title', $event)"
    />
    <v-text-field
      :value="value.subtitle"
      label="Subtitle"
      outlined
      dense
      @input="update('subtitle', $event)"
    />

    <v-divider class="my-4"></v-divider>
    <div class="subtitle-2 font-weight-bold mb-2">Column 1 (Left)</div>
    <image-uploader
      :value="value.leftImage"
      label="Left Column Image"
      @input="update('leftImage', $event)"
    />
    <div class="mb-2 caption">Tick Mark Points (Left)</div>
    <v-card v-for="(pt, i) in value.leftPoints || []" :key="'l'+i" outlined class="mb-2 pa-2 d-flex align-center">
      <v-text-field
        hide-details
        dense
        :value="pt"
        @input="updateArray('leftPoints', i, $event)"
      />
      <v-btn icon small color="error" class="ml-2" @click="removeArrayItem('leftPoints', i)">
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
    </v-card>
    <v-btn text small color="primary" @click="addArrayItem('leftPoints')">
      <v-icon small left>mdi-plus</v-icon>Add Point
    </v-btn>

    <v-divider class="my-4"></v-divider>
    <div class="subtitle-2 font-weight-bold mb-2">Column 2 (Right)</div>
    <image-uploader
      :value="value.rightImage"
      label="Right Column Image"
      @input="update('rightImage', $event)"
    />
    <div class="mb-2 caption">Tick Mark Points (Right)</div>
    <v-card v-for="(pt, i) in value.rightPoints || []" :key="'r'+i" outlined class="mb-2 pa-2 d-flex align-center">
      <v-text-field
        hide-details
        dense
        :value="pt"
        @input="updateArray('rightPoints', i, $event)"
      />
      <v-btn icon small color="error" class="ml-2" @click="removeArrayItem('rightPoints', i)">
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
    </v-card>
    <v-btn text small color="primary" @click="addArrayItem('rightPoints')">
      <v-icon small left>mdi-plus</v-icon>Add Point
    </v-btn>
  </div>
</template>

<script>
import ImageUploader from "./ImageUploader.vue";

export default {
  components: { ImageUploader },
  props: {
    value: { type: Object, default: () => ({ leftPoints: [], rightPoints: [] }) },
  },
  methods: {
    update(key, val) {
      this.$emit("input", { ...this.value, [key]: val });
    },
    updateArray(key, index, val) {
      var arr = [...(this.value[key] || [])];
      arr[index] = val;
      this.update(key, arr);
    },
    addArrayItem(key) {
      var arr = [...(this.value[key] || []), ""];
      this.update(key, arr);
    },
    removeArrayItem(key, index) {
      var arr = (this.value[key] || []).filter((_, i) => i !== index);
      this.update(key, arr);
    }
  }
};
</script>